import { render } from "./AdminChangePassword.vue?vue&type=template&id=32b37f4f"
import script from "./AdminChangePassword.vue?vue&type=script&lang=js"
export * from "./AdminChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__